var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKilometers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#D0D0D0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m10.66 10.46 3.125-3.628"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D0D0D0",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M15.997 17.25c.36-.3.697-.621 1.004-.974a8 8 0 0 0 1.901-4.113 8.2 8.2 0 0 0-.022-2.602 8 8 0 0 0-.973-2.72 8.2 8.2 0 0 0-2.978-3.013c-1.316-.778-2.743-1.163-4.496-1.162-.649-.007-1.496.128-2.32.392a8.2 8.2 0 0 0-3.029 1.735C3.623 6.116 2.73 7.748 2.428 9.686a8 8 0 0 0 .266 3.653 8.14 8.14 0 0 0 2.612 3.907"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKilometers);
export default __webpack_public_path__ + "static/media/kilometers.65ddf7d92142556096c1b882c892eb15.svg";
export { ForwardRef as ReactComponent };